'use strict';

import React from 'react';
import flux from 'utils/flux';
import store from 'store';
import trunc from 'lodash/string/trunc';
import BasketDropdown from 'components/basket/basketDropdown';
import AltContainer from 'alt-container';
import Immutable from 'immutable';
import { Navigation } from 'react-router';
import onclickoutside from 'react-onclickoutside';
import classnames from 'classnames';

var MediaListingItemInfo = React.createClass({

    displayName: 'MediaListingItemInfo',

    mixins: [
        onclickoutside,
        Navigation
    ],

    propTypes: {
        media: React.PropTypes.object
    },

    componentWillReceiveProps(nextProps) {
        if (this.props.layout != nextProps.layout){
            this.forceUpdate();
        }
    },

    shouldComponentUpdate( nextProps ) {
        return ( Immutable.is(nextProps.item, this.props.item) === false );
    },

    handleClickOutside() {
        if (this.props.item.get('_basket')) {
            flux.getActions('media').toggleBasket( this.props.item.get('id') );
        }
    },

    toggleCheck(e) {
        e.preventDefault();
        flux.getActions('media').toggleItemSelection( this.props.item.get('id') );
    },

    toggleBasket(e) {
        e.preventDefault();
        flux.getActions('media').toggleBasket( this.props.item.get('id') );
    },

    generateQuickDownload(e) {
        e.preventDefault();
        flux.getStore('basket').createBasket([{id: this.props.item.get('id')}]).then(() => {
            setTimeout(() => {
                var activeBasketId = flux.getStore('basket').getState().activeBasketId;
                this.transitionTo( 'singleBasket', { id: activeBasketId });
            }, 20);
        });
    },

    generateInstantDownload(e) {
        e.preventDefault();
        flux.getActions('modals').openInstantDownloadModal(this.props.item);
    },

    runInstantDownload(e) {
      e.preventDefault();
      const iframe = document.getElementById('download_helper');
      const id = this.props.item.toJS().id;
      const mediabox_token = store.get('mediabox_token');
      if (this.props.item.toJS().files.filter(x => x.key === 'master').length > 0) {
          iframe.src = `${window.config.baseUrl}/download?token=${mediabox_token}&${id}=master`;
          if (this.props.item.toJS().embargo) {
            flux.getActions('modals').openWatermarkModal( this.props.item );
          }
      }
    },

    renderBasket() {
        if (this.props.item.get('_basket')  && !flux.getStore('modals').getState().openModal) {
            let mediaId   = this.props.item.get('id');
            let mediaName = this.props.item.get('name') || this.props.item.get('title');
            return (
                <AltContainer
                    stores={{basketStore: flux.getStore('basket')}}
                    transform={({ basketStore }) => {
                        let baskets = basketStore.baskets;
                        return {baskets};
                    }}>
                    <BasketDropdown mediaId={mediaId} mediaName={mediaName} media={this.props.item} />
                </AltContainer>
            );
        }
    },

    renderItemMeta() {
        const item     = this.props.item.toJS();
        const MICode   = item.meta.find( meta => 'MICode' === meta.key );
        const master   = item.files && item.files.find( file => 'master' === file.key );
        const duration = master && master.meta && master.meta.find && master.meta.find( meta => 'Duration' === meta.name && !meta.hidden );
        const { hideAssetDescription } = flux.getStore('app').getState().config.toJS();
        let metaPosition = 0;

        if (hideAssetDescription && (!item.archived && !item.embargo)) {
            metaPosition = 45;
        } else if (hideAssetDescription && (item.archived || item.embargo)) {
            metaPosition = 80;
        }

        return(
            <div>
                {item.additionalText && <div className="item__additional">{item.additionalText}</div>}
                <div className="item__meta">
                    {MICode && <div className="meta__micode">{MICode.value}</div>}
                    {duration && <div className="meta__duration" style={{bottom: ((metaPosition) ? metaPosition : 0)}}>{duration.value}</div>}
                </div>
            </div>
        );
    },

    renderSlots(layout = "large_preview") {
        const slotDefinitions = this.props.slotDefinitions.toJS();
        let slots = [];
        switch(layout) {
            case 'small_preview':
                slots = window.config.tiles_small;
                break;
            case 'list_view':
                slots = window.config.list;
                break;
            default:
                slots= window.config.tiles_large;
        }
        return (<div className="slots">{
            slots.map(slot => {
                const id = slot.toString();
                const currentSlotDefinition = slotDefinitions.filter(slot => slot.id === id);
                const currentSlot = this.props.item.toJS().slots.filter(slot => slot.id === id);
                if (currentSlot[0] && (currentSlot[0].content || currentSlot[0].color || currentSlot[0].icon) && currentSlotDefinition[0]) {
                    return (
                        <div className="description__item">
                            {this.renderSlotProperties(currentSlot[0])}
                        </div>
                    );
                }
            })
        }</div>);
    },

    renderSlotProperties(slot) {
        return (
            <div className="slot">
                {Object.keys(slot).map(function(key) {
                    switch(key) {
                        case 'content':
                            return <span key={key} className={`slot-property slot-property__${key}`}> {slot[key]}</span>;;
                        case 'color':
                            return <span key={key} className={`slot-property slot-property__${key}`} style={{backgroundColor: slot[key]}}></span>;
                        case 'icon':
                            return <span key={key} className={`slot-property slot-property__${key}`}><img src={slot[key]}/></span>;
                        default:
                            return null;
                    }
                })}
            </div>
        );
    },

    render() {
        const item         = this.props.item.toJS();
        const hideActions  = false === item.showdownload || false;
        const hideCheckbox = hideActions;
        const { archiveColor, directDownload, embargoColor, hideAssetDescription } = flux.getStore('app').getState().config.toJS();
        let minHeight = null;
        const layout = this.props.layout;

        if (hideAssetDescription && (!item.archived && !item.embargo)) {
          minHeight = 44;
        } else if (hideAssetDescription && (item.archived || item.embargo)) {
          minHeight = 100;
        } else {
          minHeight = null;
        }

        return (
            <div className={classnames( 'item__info', { 'item__info--has-actions': !hideActions, 'item__info--no-actions': hideActions } )} style={{height: ((hideAssetDescription) ? 'auto' : null), minHeight: minHeight}}>
                <div className="info__top">
                    {!hideCheckbox && <div className="top__checkbox">
                        <form>
                            <div className="field__checkbox">
                                <input readOnly type="checkbox" id={'item_' + item.id} checked={item._checked} />
                                <label onClick={this.toggleCheck} htmlFor={'item_' + item.id}/>
                            </div>
                        </form>
                    </div>}
                    <div className="top__text">
                        {this.renderSlots(layout)}
                    </div>
                    {!hideActions && <div className="top__actions">
                        <div onClick={directDownload ? this.runInstantDownload : this.generateInstantDownload} className="actions__directdownload">
                            <div className="directdownload__button">
                                <i className="download" />
                            </div>
                        </div>
                        <div onClick={this.toggleBasket} className="actions__addtobasket">
                            <div className="addtobasket__button">
                                <i className="plus-small" />
                            </div>
                        </div>
                        {this.renderBasket()}
                    </div>}
                    {item.embargo && <p style={{ color: embargoColor }} className="item__embargo clearfix">embargo</p>}
                    {item.archived && <p style={{ color: archiveColor }} className="item__embargo clearfix">archive</p>}
                </div>

                {directDownload && <iframe id="download_helper" style={{ display: 'none' }}></iframe>}
            </div>
        );
    }
});

module.exports = MediaListingItemInfo;



// WEBPACK FOOTER //
// ./app/pages/media/mediaListingItemInfo.jsx